/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AllocationTarget {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return AllocationTarget.fixupPrototype; }

    static newInstance(model: Partial<AllocationTarget>): AllocationTarget {
        let obj = Object.assign(new AllocationTarget(), model);
        AllocationTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AllocationTarget>): AllocationTarget {
        if (!model) return null;
        return AllocationTarget.newInstance(<AllocationTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AllocationTarget) {
        if (!obj) return;

        models.AllocationTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AllocationTarget): boolean {
        switch (obj.__type)
        {
            case "AllocationCloudTarget":
                Object.setPrototypeOf(obj, models.AllocationCloudTarget.prototype);
                break;
            case "AllocationDimensionGroupingTarget":
                Object.setPrototypeOf(obj, models.AllocationDimensionGroupingTarget.prototype);
                break;
            case "AllocationDimensionTarget":
                Object.setPrototypeOf(obj, models.AllocationDimensionTarget.prototype);
                break;
            case "AllocationServiceAccountTarget":
                Object.setPrototypeOf(obj, models.AllocationServiceAccountTarget.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AllocationTarget)[] {
        return [
            models.AllocationCloudTarget,
            models.AllocationDimensionGroupingTarget,
            models.AllocationDimensionTarget,
            models.AllocationServiceAccountTarget,
        ];
    }

    fixupFields() {
    }

}
